<template>
  <modal v-bind="modalParams">
    <div class="dialog">
      <div
        class="dialog-content"
        ref="dialogBox">
        <div class="dialog-box-wrapper">
          <div
            class="dialog-box"
            :style="{...dialogBox}">
            <div class="dialog-text-content">
              <p
                :class="titleClasses"
                v-if="title">
                {{ title }}
              </p>
              <div v-if="contentHtml" v-html="contentHtml" />
              <pre v-else :class="contentClasses" ref="content">
                {{ content }}
              </pre>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div
          v-if="showCancel"
          class="dialog-footer-left"
          @click="handleAction('cancel')">
          <p :class="cancelClasses">
            {{ cancelText }}
          </p>
        </div>
        <div
          class="dialog-foot-btn"
          @click="handleAction('confirm')">
          <p :class="confirmClasses" class="dialog-foot-btn-text">
            {{ confirmText }}
          </p>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import mixins from '@/utils/mixins'
import Modal from '../Modal'
const MIN_T = 52 // 包含标题最小高度
const MAX_T = 262 // 包含标题最大高度
const MIN_C = 22 // 只有内容最小高度
const MAX_C = 230 // 最有内容最大高度
export default {
  components: {
    Modal
  },
  mixins: [mixins],
  data () {
    return {
      modalParams: {
        showModal: false,
        lockScroll: false
      },
      bigLineHeight: false,
      scrollBarWidth: 0,
      value: false,
      title: '',
      content: '',
      contentClass: '',
      callback: null,
      showCancel: true,
      cancelText: '',
      confirmText: '',
      confirmClass: '',
      cancelClass: '',
      contentHtml: ''
    }
  },
  computed: {
    dialogBox () {
      const min = this.title ? this.pxGo(MIN_T) : this.pxGo(MIN_C)
      const max = this.title ? this.pxGo(MAX_T) : this.pxGo(MAX_C)
      return (max == 0) ? { minHeight: `${min}px` } : { minHeight: `${min}px`, maxHeight: `${max}px` }
    },
    titleClasses () {
      const classes = `dialog-title ${this.titleClass}`
      return classes
    },
    contentClasses () {
      // eslint-disable-next-line
      const lineHeightClass = this.bigLineHeight ? 'dialog-big-lineheight' : 'dialog-small-lineheight'
      const classes = `${lineHeightClass} dialog-text ${this.contentClass}`
      return classes
    },
    cancelClasses () {
      const classes = `dialog-foot-btn-text dialog-footer-left-text${this.cancelClass}`
      return classes
    },
    confirmClasses () {
      const classes = `dialog-foot-btn-text${this.confirmClass}`
      return classes
    }
  },
  watch: {
    value (newVal) {
      this.modalParams.showModal = newVal
      const stopScroll = newVal
      this.stopBodyScroll(stopScroll)
      if (newVal) {
        this.scrollBarWidth = this.getScrollBarWidth()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      const contentRef = this.$refs.content
      const height = contentRef && contentRef.clientHeight
      if (height <= 80 && !this.title) {
        this.bigLineHeight = true
      }
    }, 0)
  },
  methods: {
    handleAction (action) {
      this.value = false
      this.callback(action)
    }
  }
}
</script>
<style lang="scss">
@mixin diglogBtn {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 100%;
}
@mixin dialog-text {
  color: $color-bg-black;
  font-size: $span-font-size;
  line-height: 20px;
  white-space: pre-line;
  text-align: center;
}
.dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 270px;
  border-radius: 4px;
  background: $color-bg-white;
  transform: translate(-50%, -50%);
  .dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 30px 20px;
    .dialog-box-wrapper {
      .dialog-box {
        height: 100%;
        // padding-right: 0.5px;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        .dialog-text-content {
          height: auto;
          padding-right: 1px;
        }
      }
    }
  }
  .dialog-footer {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    height: 50px;
    @include border-top;
  }
}
.dialog-title {
  @include font-Helvetica;

  margin-bottom: 10px;
  color: $color-bg-black;
  font-size: $base-font-size;
  line-height: 22px;
  text-align: center;
}
.dialog-text {
  @include dialog-text;
}
.dialog-text-left {
  @include dialog-text;

  text-align: left;
}
.dialog-text-right {
  @include dialog-text;

  text-align: right;
}
.dialog-foot-btn {
  @include diglogBtn;
}
.dialog-foot-btn-text {
  @include font-Medium;

  color: $color-primary;
  font-size: $base-font-size;
}
.dialog-footer-left {
  @include diglogBtn;
  @include border-right;
}
.dialog-footer-left-text {
  color: $color-text;
}
.dialog-footer-left-texteb-delete {
  color: #f7605c;
}
.dialog-big-lineheight {
  line-height: 22px;
}
.dialog-small-lineheight {
  line-height: 20px;
}
</style>
